/* global document, window */
'use strict';

module.exports = rebalance;

function rebalance() {
    var hubs = document.querySelectorAll('.m-card-group--container');

    Array.prototype.forEach.call(hubs, rebalanceHub);
}

function rebalanceHub(hub) {
    var cardGroups = hub.querySelectorAll('.m-card-group--content'),
        groupSize = hub.getAttribute('data-group-size'),
        firstGroupSize = hub.getAttribute('data-first-group-size');

    if (!groupSize) {
        return;
    }

    var cards = getAllCards(cardGroups);
    var visibleCards = cards.filter(isElementVisible);
    var adCards = findAdCards(cardGroups);

    for (var groupIndex = 0; groupIndex < cardGroups.length; groupIndex++) {
        var group = cardGroups[groupIndex];
        placeCardsInGroup(group, groupIndex);
    }

    var lastGroupWithVisibleCards = findLastGroupWithVisibleCards(hub);

    hideAllStreamElementsAfter(lastGroupWithVisibleCards, hub);

    function placeCardsInGroup(group, groupIndex) {
        var desiredCardCount = groupIndex === 0 && firstGroupSize ? firstGroupSize : groupSize;
        var placedCardCount = 0;
        var adCard = getNextAdCard(groupIndex);

        while (cardsCanBePlacedInGroup()) {
            var card = cards.shift();

            // Ad cards must not be moved in the DOM,
            // due to them containing iframes (which
            // would get destroyed), so we skip them here
            // and handle their placement another way.
            if (isAdCard(card)) {
                continue;
            }

            group.insertBefore(card, adCard && adCard.element);

            if (isCardVisible(card)) {
                placedCardCount++;
            }

            if (shouldPlaceAdCard()) {
                // We "place" ad cards by inserting other cards before them
                // and then moving on to the next one at the right time.
                if (isCardVisible(adCard.element)) {
                    placedCardCount++;
                }

                adCard = getNextAdCard(groupIndex);
            }
        }

        function cardsCanBePlacedInGroup() {
            return cards.length && placedCardCount < desiredCardCount;
        }

        function shouldPlaceAdCard() {
            return adCard && adCard.cardsBefore === placedCardCount;
        }
    }

    function isCardVisible(card) {
        return visibleCards.indexOf(card) !== -1;
    }

    function getNextAdCard(groupIndex) {
        var element = adCards[groupIndex].shift();

        return element
            ? {
                  element: element,
                  cardsBefore: parseInt(element.getAttribute('data-cards-before')),
              }
            : null;
    }

    function findLastGroupWithVisibleCards(hub) {
        var groups = hub.querySelectorAll('.m-card-group');

        for (var i = 0; i < groups.length; i++) {
            var groupContents = groups[i].querySelector('.m-card-group--content');

            if (!elementsToArray(groupContents.children).filter(isCardVisible).filter(isNotAdCard).length) {
                return groups[i - 1];
            }
        }
    }
}

function getAllCards(groups) {
    var allCards = [];
    for (var i = 0; i < groups.length; i++) {
        var cardGroup = groups[i];
        var cards = elementsToArray(cardGroup.children);
        allCards = allCards.concat(cards);
    }
    return allCards;
}

function findAdCards(groups) {
    var adCards = [];
    for (var i = 0; i < groups.length; i++) {
        var group = groups[i];
        var cards = elementsToArray(group.children);

        adCards.push(cards.filter(isAdCard));
    }
    return adCards;
}

function isAdCard(card) {
    return card.hasAttribute('data-cards-before');
}

function isNotAdCard(card) {
    return !isAdCard(card);
}

function hideAllStreamElementsAfter(elementToHideAfter, hub) {
    var elements = hub.children,
        isAfterElement = false;

    for (var i = 0; i < elements.length; i++) {
        var element = elements[i];

        element.style.display = shouldBeVisible(element) ? null : 'none';

        if (element === elementToHideAfter) {
            isAfterElement = true;
        }
    }

    function shouldBeVisible(el) {
        return !isAfterElement || isStreamFooter(el);
    }

    function isStreamFooter(el) {
        return element.classList.contains('m-component-footer--container');
    }
}

function elementsToArray(elements) {
    return Array.prototype.slice.call(elements);
}

function isElementVisible(element) {
    return !!(element.offsetParent || window.getComputedStyle(element).display !== 'none');
}
